import React, {Component} from 'react';

export class DisplayText extends Component {
  render() {
    return <p> {this.props.guidance}</p>;
  }
}
